<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<AuthForm :title="$t('general.resetPassword')"
	          :button-label="$t('general.changePassword')"
	          @submit="changePassword">
		<template v-slot:formFields>
			<v-col cols="12">
				<v-text-field
						class="custom_textfield"
						v-model="user.password"
						id="password"
						:error-messages="passwordErrors"
						:label="$t('general.password')"
						:clearable=true
						name="password"
						prepend-inner-icon="lock"
						type="password"
						@input="$v.user.password.$touch()"
						@blur="$v.user.password.$touch()"
						outlined
				></v-text-field>
			</v-col>
			<v-col cols="12">
				<v-text-field
						class="custom_textfield"
						id="confirm_password"
						name="confirm_password"
						v-model="user.password_confirmation"
						:error-messages="confirmPasswordErrors"
						:label="$t('general.confirmPassword')"
						:clearable=true
						prepend-inner-icon="lock"
						type="password"
						@input="$v.user.password_confirmation.$touch()"
						@blur="$v.user.password_confirmation.$touch()"
						outlined
				></v-text-field>
			</v-col>
		</template>
	</AuthForm>

</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, minLength, sameAs} from 'vuelidate/lib/validators'
    import AuthForm from '../components/AuthForm.vue'

    export default {
        mixins: [validationMixin],
        components: {
            AuthForm
        },
        props: ['token'],
        validations: {
            user: {
                password: {
                    required,
                    minLength: minLength(6)
                },
                password_confirmation: {
                    required,
                    minLength: minLength(6),
                    sameAs: sameAs('password')
                }
            }
        },
        mounted() {
            this.user.token = this.token
        },
        data: () => ({
            drawer: null,
            user: {
                password: '',
                password_confirmation: '',
                token: ''
            }
        }),
        computed: {
            passwordErrors() {
                const errors = [];
                if (!this.$v.user.password.$dirty) return errors;
                !this.$v.user.password.required && errors.push(this.$t('validation.required'));
                !this.$v.user.password.minLength && errors.push(this.$t('validation.minLength', {num: this.$v.user.password.$params.minLength.min}));
                return errors;
            },
            confirmPasswordErrors() {
                const errors = [];
                if (!this.$v.user.password_confirmation.$dirty) return errors;
                !this.$v.user.password_confirmation.required && errors.push(this.$t('validation.required'));
                !this.$v.user.password_confirmation.minLength && errors.push(this.$t('validation.minLength', {num: this.$v.user.password.$params.minLength.min}));
                !this.$v.user.password_confirmation.sameAs && errors.push(this.$t('validation.passwordsMustMatch'));
                return errors;
            }
        },
        methods: {
            changePassword() {
                // Check if form input is valid.
                this.$v.user.$touch();

                if (!this.$v.user.$invalid) {
                    // send request to server
                    axios.post(`${this.$store.state.api_url}/api/password-reset`, this.user)
                        .then(async response => {
                            await this.$store.dispatch('showResponseNotification', {
                                "response": response,
                                "timeout": 3000
                            });
                            this.$router.push('/login');
                        })
                        .catch(error => {
                            this.$store.dispatch('showResponseNotification', {
                                "response": error.response,
                                "timeout": 5000
                            });
                        })
                }
            },
        }
    }
</script>